<template>
  <v-dialog
    v-model="dialog"
    max-width="90vh"
    scrollable
    :retain-focus="false"
    persistent
  >
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />

    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >

    <v-card height="100%">
      <v-toolbar color="primary" dark>{{ titleForm }}</v-toolbar>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row class="mt-3">
            <v-col cols="12" md="3">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :nudge-top="20"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newDate"
                    label="Date"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="newDate" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                label="Transaction Methods"
                :items="transactionMethods"
                v-model="newTransactionMethods"
                @change="onSelectTransactionMethods"
                outlined
                :rules="requiredField"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="newType"
                label="Transaction Type"
                :items="type"
                outlined
                :rules="requiredField"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="Amount"
                prefix="$"
                v-model="newAmount"
                outlined
                :hint="`Remaining Balance ${remainingBalance}`"
                type="number"
                :rules="requiredField"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5" v-if="newType === 'Expense'">
            <v-col cols="12" md="4">
              <v-text-field
                label="Payee"
                v-model="newPayee"
                outlined
                :rules="requiredField"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="Category"
                :items="categories"
                v-model="newExpenseCategory"
                outlined
                :rules="requiredField"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="City of Purchase"
                v-model="newPurchaseLocation"
                outlined
                :rules="requiredField"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-n5" v-if="newType === 'Deposit'">
            <v-col cols="12" md="3">
              <v-select
                label="Category"
                :items="depositCategories"
                v-model="newDepositCategory"
                outlined
                :rules="requiredField"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mt-n5">
            <v-col cols="12" md="12">
              <v-textarea
                outlined
                label="Notes"
                v-model="newNotes"
                :rules="requiredField"
              ></v-textarea>
            </v-col>
          </v-row>
          <div>
            Was the receipt signed by the staff and client?
            <v-row class="ml-1">
              <v-radio-group :rules="requiredField" v-model="newSigned">
                <v-radio label="Yes" value="Yes"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>
              <!-- <v-switch
                label="Yes"
                value="Yes"
                v-model="newSigned"
                class="mr-3"
              ></v-switch>
              <v-switch label="No" value="No" v-model="newSigned"></v-switch> -->
            </v-row>
          </div>

          <v-row class="mt-1">
            <v-col cols="12" md="12" v-if="newType != 'Deposit'">
              <form enctype="multipart/form-data">
                <v-file-input
                  ref="receipt"
                  label="Upload Receipt"
                  prepend-icon="mdi-camera"
                  accept="image/*, .pdf"
                  @change="imgSelected"
                  outlined
                  hint="images must be a png, jpg, jpeg or pdf"
                  v-model="newReceipt"
                  :rules="requiredField"
                ></v-file-input>
                <template>
                  <!-- <span>{{ newReceipt }}</span> -->
                  <v-card class="pa-3 mb-2" v-show="newReceiptImage">
                    <div v-for="(item, i) in newReceiptImage" :key="i">
                      <v-img
                        :src="item.aws"
                        height="300"
                        contain
                        v-if="item.ext != 'pdf'"
                      ></v-img>

                      <div v-if="item.ext == 'pdf'">
                        <LoadPDF :pdfFile="item.aws" :pdfName="item.name" />
                      </div>
                    </div>
                  </v-card>
                </template>
                <div v-if="(uploadImg != null && editFinance) || uploadImg">
                  File: <span>{{ uploadImg.name }}</span>
                  <!-- <v-text-field
                    label="Rename File"
                    v-model="renameFiles"
                    outlined
                    disabled
                  ></v-text-field> -->
                </div>
              </form>
            </v-col>
          </v-row>

          <v-row class="mt-n8">
            <v-col cols="12" md="12">
              <v-checkbox
                v-model="checkedSignature"
                label="Signature"
                hide-details
                @change="addSignature($event)"
                :rules="requiredField"
              ></v-checkbox>
              <v-text-field v-model="newSignature"></v-text-field>
            </v-col>
          </v-row>

          <div>
            <v-container>
              <v-img
                max-height="80"
                max-width="150"
                :src="newClientSignature"
              ></v-img>
            </v-container>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="white--text"
          color="primary"
          @click.stop="showSignaturePad = true"
        >
          <div class="text-caption text-sm-body-1">Client Signature</div></v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isAuditorRole"
          class="white--text"
          :color="editFinance ? 'blue darken-1' : '#259647'"
          @click="editFinance ? onUpdateItem() : onAddItem()"
          :disabled="isSaving"
        >
          <div class="text-caption text-sm-body-1">
            {{ buttonState }}
          </div>
        </v-btn>
        <v-btn color="blue darken-1" text @click="close">
          <div class="text-caption text-sm-body-1">Cancel</div></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import moment from "moment";
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import { setUserTz, tz } from "../../../utils/timezone";
import LoadPDF from "@/components/LoadPDF.vue";
import renameFileHelper from "@/mixins/renameFileHelper";
const url = require("../../client_config/config").url;

export default {
  // props: ["financeData", "currentBalance", "clientID"],
  mixins: [renameFileHelper],
  props: {
    clientID: {
      type: String,
      default: "",
    },
    financeID: {
      type: String,
      default: "",
    },
    isAuditorRole: {
      type: Boolean,
      defaul: false
    }
  },
  components: {
    SignaturePad,
    LoadPDF,
  },
  data() {
    return {
      newItem: false,
      newDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      newAction: "",
      newTransactionMethods: "",
      newType: "",
      newAmount: "",
      newPayee: "",
      newExpenseCategory: "",
      newPurchaseLocation: "",
      newDepositCategory: "",
      newNotes: "",
      newSignature: "",
      newClientSignature: null,
      signaturepop2: false,
      newBalance: 0,
      newSigned: "",
      newReceipt: null,
      newReceiptImage: null,
      newFinance: false,
      titleForm: "New Finance",
      action: ["Expense", "Deposit"],
      transactionMethods: ["Cash", "Debit Card", "EBT"],
      categories: [
        "Food",
        "Fast Food",
        "Personal Care",
        "Automotive",
        "Fuel",
        "Cigarettes",
        "Alcohol",
        "Entertainment",
        "Gifts",
        "Charity",
        "Bank Fee's",
        "Medical",
        "Dental",
        "Insurance",
        "Rent",
        "Utilities",
        "Phone",
        "Other",
      ],
      depositCategories: [
        "Benefits",
        "Employment Income",
        "Gift Income",
        "Interests",
        "Other Income",
        "Reimbursement Income",
        "Rollover",
        "SSI Income",
        "Wages",
        "Other",
      ],
      type: ["Expense", "Deposit"],
      uploadImg: null,
      originalfileName: "",
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      signed: false,
      showSignaturePad: false,
      checkedSignature: false,
      editFinance: false,
      maxDate: "",
      minDate: "",
      balance: this.currentBalance,
      financeTransctionID: "",
      isSaving: false,
      buttonTxt: "",
      renameFiles: null,
      oldAmount: 0,
      isPDF: false,
      remainingBalance: 0,
      requiredField: [(v) => !!v || "This is required"],
    };
  },

  async created() {
    // await this.getFinances(this.clientID);
    console.log("created");
  },

  computed: {
    // ...mapGetters(["getFinanceData", "financeDate"]),

    dialog: {
      get() {
        return this.$store.state.financeTransactions.financeDialog;
      },
      set(val) {
        this.$store.commit("financeTransactions/SET_FINANCE_DIALOG", val);
      },
    },

    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    buttonState() {
      let state = "";
      if (this.editFinance) {
        state = "Update";
      } else {
        state = "Save";
      }
      if (this.isSaving) {
        state = "Saving....";
      }
      return state;
    },
  },

  methods: {
    ...mapActions({
      getFinance: "finances/getFinance",
      addFinanceTransaction: "financeTransactions/addFinanceTransaction",
      updateFinanceTransaction: "financeTransactions/updateFinanceTransaction",
    }),

    validate() {
      return this.$refs.form.validate();
    },

    signatureData(data) {
      this.newClientSignature = data;
    },

    // async setDate() {
    //   let finance = await this.getFinance(this.financeID);
    //   //this.minDate = moment(new Date(filterTransactionDate?.Date))
    //   this.minDate = tz(finance.data.Date, this.userTimezone)
    //     .startOf("month")
    //     .format("YYYY-MM-DD");
    //   //this.maxDate = moment(new Date(filterTransactionDate?.Date))
    //   this.maxDate = tz(finance.data.Date, this.userTimezone)
    //     .endOf("month")
    //     .format("YYYY-MM-DD");
    //   //this.newDate = moment(new Date(filterTransactionDate?.Date))
    //   this.newDate = tz(finance.data.Date, this.userTimezone).format("YYYY-MM-DD");

    // },

    onViewItem(item) {
      this.titleForm = `Viewing ${item.Month} - ${item.ClientName}`;
      this.financeTransctionID = item._id;
      this.editFinance = true;
      this.newDate = tz(item.Date, this.userTimezone).format("YYYY-MM-DD");
      this.newAmount = item.Amount.$numberDecimal;
      this.newTransactionMethods = item.TransactionMethods;
      this.newType = item.TransactionType;
      this.newNotes = item.Notes;
      this.newSigned = item.Signed;
      this.newPayee = item.Payee;
      this.newPurchaseLocation = item.PurchaseLocation;
      this.newDepositCategory = item.DepositCategory;
      this.newExpenseCategory = item.ExpenseCategory;
      this.newSignature = item.StaffSignature
        ? ((this.checkedSignature = true), item.StaffSignature)
        : ((this.checkedSignature = false), "");
      this.newClientSignature = item.ClientSignature;

      if (item?.Receipt != "" && item?.Receipt != undefined) {
        let AWSLink = item.Receipt?.AWSLink || "";
        const documentDetails = [];
        let fileExt = AWSLink.split(".").pop();
        documentDetails.push({
          aws: AWSLink,
          name: AWSLink,
          ext: fileExt,
        });

        this.newReceiptImage = documentDetails;
        
        if (this.newType != "Deposit" && item?.Receipt?.Name != "" && item?.Receipt?.Name != undefined) {
          this.newReceipt = {
            name: item.Receipt.Name,
            ext: fileExt,
            id: item.Receipt._id,
            awsLink: AWSLink,
          };
        }
      }

      this.oldAmount = item.Amount.$numberDecimal;
    },
    /*
    async loadPdf(url) {
      // Fetch an existing PDF document.
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer()
      );
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const fDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      document.getElementById("pdf").src = fDataUri;
    },
*/
    async onAddItem() {
      if (this.validate()) {
        this.isSaving = true;
        this.onSelectType(this.newType);
        var req_body = {
          Date: this.newDate,
          TransactionMethods: this.newTransactionMethods,
          TransactionType: this.newType,
          Amount: this.newAmount,
          Payee: this.newPayee,
          ExpenseCategory: this.newExpenseCategory,
          PurchaseLocation: this.newPurchaseLocation,
          DepositCategory: this.newDepositCategory,
          Notes: this.newNotes,
          StaffSignature: this.newSignature,
          ClientSignature: this.newClientSignature,
          Signed: this.newSigned,
          ClientID: this.clientID,
          FinanceID: this.financeID,
        };
        if (!this.newClientSignature) {
          this.msg = true;
          this.text = "Please add signature";
          this.isSaving = false;
          return;
        }
      }

      const response = await this.addFinanceTransaction(req_body);

      if (!response.success) {
        this.isSaving = false;
        return alert(response.message);
      }

      if (this.uploadImg !== null && this.uploadImg !== undefined) {
        await this.saveImg(response.data._id);
      }
      this.isSaving = false;
      this.close();
      this.$emit("get-finance-transactions");
    },

    async onUpdateItem() {
      this.isSaving = true;
      this.onSelectType(this.newType);

      if (!this.validate()) return this.isSaving = false;

      if (!this.newClientSignature) {
        this.msg = true;
        this.text = "Please add signature";
        this.isSaving = false;
        return;
      }

      var req_body = {
        Date: this.newDate,
        TransactionMethods: this.newTransactionMethods,
        TransactionType: this.newType,
        Amount: this.newAmount,
        Payee: this.newPayee,
        ExpenseCategory: this.newExpenseCategory,
        DepositCategory: this.newDepositCategory,
        PurchaseLocation: this.newPurchaseLocation,
        Notes: this.newNotes,
        StaffSignature: this.newSignature,
        ClientSignature: this.newClientSignature,
        Signed: this.newSigned,
        ClientID: this.clientID,
        FinanceID: this.financeID,
        OldAmount: this.oldAmount,
      };

      const response = await this.updateFinanceTransaction({
        req_body,
        id: this.financeTransctionID,
      });

      if (!response.success) {
        this.isSaving = false;
        return alert(response.message);
      }

      if (this.uploadImg !== null && this.uploadImg !== undefined) {
        await this.saveImg(response.data._id);
      }
      this.isSaving = false;
      this.close();
      this.$emit("get-finance-transactions");
    },

    addSignature(e) {
      if (!e) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.signed = true;
    },

    close() {
      this.dialog = false;
      this.editFinance = false;
      this.clear();
    },

    async imgSelected(e) {
      let newName = this.newPayee + "-receipt";
      if (this.newPayee == "") {
        newName = "payee-receipt";
      }

      let filename = null;

      if (e != null) {
        filename = await this.renameFileHelper(
          e,
          this.$store.state.finances.items[0].ClientName,
          newName,
          this.newDate
        );
      }

      if (e === null) {
        this.renameFiles = null;
        this.originalfileName = "";
      } else {
        this.originalfileName = filename;
      }

      this.uploadImg = filename;
    },

    async saveImg(id) {
      const fileToBeUpload = this.renameFile(this.uploadImg, this.renameFiles);
      const formData = new FormData();
      formData.append("receipt-img", fileToBeUpload);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      await axios.post(
        `${url}/financeTransactions/imguploader/${id}/${this.clientID}`,
        formData,
        ct
      );
    },

    renameFile(file, newFileName) {
      let ext = file.name.split(".").pop();
      let filename = newFileName != null ? `${newFileName}.${ext}` : file.name;
      return new File([file], `${filename}`, {
        type: file.type,
      });
    },

    onSelectType(item) {
      if (item === "Expense") {
        this.newDepositCategory = "";
      } else {
        this.newExpenseCategory = "";
        this.newPayee = "";
        this.newPurchaseLocation = "";
      }
    },

    onSelectTransactionMethods(e) {
      let finance = this.$store.state.finances.items.find(
        (item) => item._id === this.financeID
      );

      Object.keys(finance).forEach((key) => {
        if (e === "Debit Card") {
          return (e = "DebitCard");
        }

        if (key === e) {
          this.remainingBalance = finance[key].$numberDecimal || 0;
          return this.remainingBalance;
        }
      });
    },

    clear() {
      this.newDate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.newAmount = "";
      this.newTransactionMethods = "";
      this.newType = "";
      this.newNotes = "";
      this.newPayee = "";
      this.newExpenseCategory = "";
      this.newPurchaseLocation = "";
      this.newDepositCategory = "";
      this.newSignature = "";
      this.newSigned = "";
      this.newClientSignature = null;
      this.newReceipt = null;
      this.newReceiptImage = null;
      this.rules = [];
      this.checkedSignature = false;
      this.uploadImg = null;
      this.isSaving = false;
      this.$refs.form.reset();
      if (this.newReceipt == null || this.newReceipt == "") {
        return;
      } else {
        this.$refs.receipt.reset();
      }
    },
  },
};
</script>
